<template>
    <div class="bf __slot">
        <slot></slot>
    </div>
    <div class="">
        <div class="form">
            <Transition mode="out-in">
                <form v-if="!complite" action="/buy/ticket" method="post">
                    <div class="input">
                        <input 
                            :value="inn" @input="e => inn = e.target.value"
                            name="inn" type="text" placeholder="ИНН *" :required="true" :class="{ 'valid': innValid, 'invalid': !innValid && inn }">
                    </div>
                    <div class="input">
                        <input 
                            :value="company" @input="e => company = e.target.value"
                            name="company" type="text" placeholder="Название компании *" :required="true" :class="{ 'valid': companyValid, 'invalid': !companyValid && company }">
                    </div>
                    <div class="input">
                        <input 
                            :value="bik" @input="e => bik = e.target.value"
                            name="bik" type="text" placeholder="БИК банка *" :required="true" :class="{ 'valid': bikValid, 'invalid': !bikValid && bik }">
                    </div>
                    <div class="input">
                        <input 
                            :value="rschet" @input="e => rschet = e.target.value"
                            name="rschet" type="text" placeholder="Расчётный счёт *" :required="true" :class="{ 'valid': rschetValid, 'invalid': !rschetValid && rschet }">
                    </div>
                    <div class="input">
                        <input 
                            :value="email" @input="e => email = e.target.value"
                            name="email" type="text" placeholder="Адрес электронной почты *" :required="true" :class="{ 'valid': emailValid, 'invalid': !emailValid && email }">
                    </div>
                    <div class="input">
                        <input 
                            :value="name" @input="e => name = e.target.value"
                            name="name" type="text" placeholder="Имя контактного лица *" :required="true" :class="{ 'valid': nameValid, 'invalid': !nameValid && name }">
                    </div>
                    <div class="input">
                        <input 
                            :value="tel" @input="e => tel = e.target.value"
                            name="tel" type="text" placeholder="Контактный телефон *" :required="true" :class="{ 'valid': telValid, 'invalid': !telValid && tel }">
                    </div>
                    <div class="input">
                        <textarea 
                            :value="text" @input="e => text = e.target.value"
                            :required="false"
                            name="text"
                            placeholder=""
                            rows="3"
                        ></textarea>
                    </div>
                    <div class="__tickets">
                        <!-- <div class="__row"> -->
                            <div v-for="(ticket, index) in buy" :key="index"
                                class="__ticket"
                            >
                                <div class="__title">
                                    {{ ticket.title }}
                                </div>
                                <div class="__action">
                                    <button
                                        @click.prevent="event => handleClickPlus(event, index, false)"
                                    >-</button>
                                    {{ ticket.count }}
                                    <!-- <input 
                                        :value="buy[ticket.id].value"
                                        @input="e => buy[ticket.id].value = e.target.value"
                                        type="number" 
                                    /> -->
                                    <button
                                        @click.prevent="event => handleClickPlus(event, index, true)"
                                    >+</button>
                                </div>
                            </div>
                            <!-- <div class="__cost">{{ buySumFormat }}</div> -->
                        <!-- </div> -->
                    </div>

                    <Transition mode="out-in">
                        <div v-if="!waiting" class="submit">
                            <!-- <small>Далее Вы будуте перенаправлены на страницу платёжной системы</small> -->
                            <button @click.prevent="handleClickBuy" :disabled="disabled">Отправить заказ</button>
                        </div>
                        <div v-else class="waiting">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </Transition>
                </form>
                <div v-else class="complite">
                    <template v-if="statusOk">
                        <p>Благодарим за заказ! Мы с Вами свяжемся в рабочее время, пн-пт с 10:00 до 18:00 для подтверждения деталей заказа.</p>
                    </template>
                    <template v-else>
                        <p>Ой, что-то пошло не так. Попробуйте чуть тозже.</p>
                    </template>
                </div>
            </Transition>
        </div>
    </div>
    <!-- <Transition>
        <PersonalBlock v-if="isOpenPersonal" @close-personal="handleClickPersonal"/>
    </Transition> -->
</template>
<script>
import { validationEmail, validationName, validationTel } from '@/lib/validation';
import tariff from '@/lib/tariff'
// import PersonalBlock from '@/components/PersonalBlock.vue';
export default {
    name: 'BuyForm',
    components: {},
    props: {
        sendResult: Object,
        statusOk: Boolean,
        complite: Boolean,
        waiting: Boolean,
        promocodeEnabled: {
            type: Boolean,
            default: () => false,
        }
    },
    data() {
        return {
            inn: '',
            innValid: null,
            company: '',
            companyValid: null,
            bik: '',
            bikValid: null,
            rschet: '',
            rschetValid: null,
            email: '',
            emailValid: null,
            name: '',
            nameValid: null,
            tel: '',
            telValid: null,
            text: '',
            timer: null,
            tariff,
            // tickets: [
            //     ...tariff.list
            // ],
            buy: [],
        }
    },
    emits: [ 'eventReturnData' ],
    mounted() {
        this.tariff.list.forEach(element => {
            this.buy.push(
                { 
                    title: element.title,
                    id: element.id,
                    cost: element.cost,
                    count: 0,
                 }
            )
        });
    },
    methods: {
        handleClickPlus: function(event, index, action = true ) {
            /**
             * @param action true = plus, false = minus
             */
            if ( action ) {
                this.buy[index].count++
            }else{
                if ( this.buy[index].count > 1 ) {
                    this.buy[index].count--
                }else{
                    this.buy[index].count = 0
                }
            }
        },
        handleClickBuy: function() {
            this.$emit('eventReturnData', { 
                form: 'buyticket-company',
                inn: this.inn,
                company: this.company,
                bik: this.bik,
                rschet: this.rschet,
                email: this.email,
                name: this.name,
                tel: this.tel,
                text: this.text,
                buy: this.buy
             } )
        },

        validationInn: function(value) {
            let valid = false
            value = value.replace( /[^0-9]/ , "" )
            if ( value.length >= 10 && value.length <= 12 ) {
                valid = true
            }
            return { value, valid }
        },
        validationCompany: function(value) {
            let valid = false
            if ( value.length > 3 ) {
                valid = true
            }
            return { value, valid }
        },
        validationBik: function(value) {
            let valid = false
            value = value.replace( /[^0-9]/ , "" )
            if ( value.length == 9 ) {
                valid = true
            }
            return { value, valid }
        },
        validationRschet: function(value) {
            let valid = false
            value = value.replace( /[^0-9]/ , "" )
            if ( value.length == 20 ) {
                valid = true
            }
            return { value, valid }
        },

        validationEmail,
        validationTel,
        validationName,

    },
    watch: {
        inn: function(newValue, oldValue){
            let res = this.validationInn(newValue, oldValue)
            this.inn = res.value
            this.innValid = res.valid
        },
        company: function(newValue, oldValue){
            let res = this.validationCompany(newValue, oldValue)
            this.company = res.value
            this.companyValid = res.valid
        },
        bik: function(newValue, oldValue){
            let res = this.validationBik(newValue, oldValue)
            this.bik = res.value
            this.bikValid = res.valid
        },
        rschet: function(newValue, oldValue){
            let res = this.validationRschet(newValue, oldValue)
            this.rschet = res.value
            this.rschetValid = res.valid
        },
        name: 'validationName',
        tel: 'validationTel',
        email: 'validationEmail',
        // buySum: function(newValue) {
            
        // }
        // sendResult: function(result) {
            
        //     // console.log('result', result )
        //     if ( result.status === 200 ) {
        //         if ( result.data.code === 200 ) {
        //             this.waiting = false 
        //             this.complite = true
        //             // this.statusOk = true
        //         } else {
        //             this.waiting = false 
        //             this.complite = true
        //             // this.statusOk = false
        //         }
        //     } else {
        //         this.waiting = false 
        //         this.complite = true
        //         // this.statusOk = false
        //     }
        //     this.timer = setTimeout(() => {
        //         this.flushState()
        //     }, 15000 );
        // },
    },
    computed: { 
        disabled: function() {
            if ( 
                this.innValid
                && this.companyValid
                && this.bikValid
                && this.rschetValid
                && this.emailValid 
                && this.nameValid 
                && this.telValid
                && this.buySum
            ) {
                return false
            }
            return true
        },
        buySum: function() {
            let sum = 0
            this.buy.forEach( ticket =>{
                sum = sum + ticket.cost * ticket.count
            })
            return sum
            // return Intl.NumberFormat('ru-RU', { 
            //     style: 'currency',
            //     currency: 'RUB',
            //     maximumFractionDigits: 0,
            // }).format( sum )
        },
        buySumFormat: function() {
            return Intl.NumberFormat('ru-RU', { 
                style: 'currency',
                currency: 'RUB',
                maximumFractionDigits: 0,
            }).format( this.buySum )
        }
        // buySum: {

        // }
        // buyValid: function() {

        // },
    }
}
</script>
<style lang="scss">
$primary: #1E9BD8;
$secondary: #45289C;
.form{
    // background-color: #243255;
    background-color: $secondary;
    background-image: none;
    color: #fff;
    font-size: 1.25em;
    .__tickets{
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        margin-bottom: 10px;
        .__ticket{
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            // border-bottom: solid 1px #fffc;
            .__title{
                flex-grow: 1;
                text-align: start;
                font-weight: 200;
                font-size: 1em;
            }
            .__action{
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                // word-wrap: break-word;
                // flex-wrap: nowrap;
            }
        }
        button{
            background: none;
            border-radius: 50%;
            border: solid 0px $primary;
            color: #fff;
            height: 24px;
            width: 24px;
            line-height: 0;
            margin: 4px 8px;
            font-size: 1em;
        }
        .__cost{
            text-align: end;
            border-top: solid 1px #fffc;
            margin-right: 8px;
            padding: 15px;
        }
    }
    .notes{
        font-size: .85em;
        margin-bottom: 1.25em;
        text-align: left;
        color: $primary;
        text-transform: uppercase;
    }
    .input{
        margin-bottom: 1em;
        &:last-child{
            margin-bottom: 0;
        }
        flex-basis: 100%;
        display: flex;
        label{
            flex-grow: 1;
            flex-basis: 12%;
            text-align: end;
            padding-right: .25em;
            @media ( max-width: 992px) {
                display: none;
            }
        }
        input{
            border: solid 1px $primary;
            background-color: $secondary;
            color: #fff;
            border-radius: 16px;
            height: 24px;
            width: 100%;
            font-size: .8em;
            transition: .4s;
            padding: .25em .85em;
            &.invalid:not(:focus){
                background-color: #dc3030;
            }
            &.valid:focus{
                background-color: #72c15d;
            }
            &::placeholder{
                color: #ffffff;
                font-size: .8em;
            }
            &:focus{
                transition: .4s;
                outline: #fff;
                // background-color: lighten($primary, 15%);
                background-color: darken($primary, 5%);
            }
        }
        textarea{
            width: 100%;
            border: solid 1px $primary;
            background-color: $secondary;
            color: #fff;
            border-radius: 16px;
            font-size: .8em;
            transition: .4s;
            padding: .85em .85em;
            &.invalid:not(:focus){
                background-color: #dc3030;
            }
            &.valid:focus{
                background-color: #72c15d;
            }
            &::placeholder{
                color: #ffffff;
                font-size: .8em;
            }
            &:focus{
                transition: .4s;
                outline: #fff;
                // background-color: lighten($primary, 15%);
                background-color: darken($primary, 5%);
            }
        }
    }
    .submit{
        display: flex;
        flex-direction: column;
        // justify-content: flex-end;
        small{
            width: 100%;
            // font-weight: 100;
            font-size: .65em;
            text-align: center;
            color: darken(#fff, 15%);
            .personal{
                // text-transform: none;
                // background-color: transparent;
                // padding: 0;
                color: darken(#fff, 10%);
                // border-bottom: solid 1px #fff;
                // border-radius: 0;
            }
            padding-bottom: 1em;
        }
        button{
            font-size: 1em;
            padding: .5em .85em;
            text-transform: uppercase;
            color: #fff;
            border: #fff;
            border-radius: 16px;
            background-color: $primary;
            transition: .4s;
            cursor: pointer;
            &:disabled{
                background-color: #fff2;
                cursor: auto;
                // color: darken($secondary, 5%);
                color: #fff6;
                transition: .4s;
            }
            @media ( max-width: 992px) {
                width: 100%
            }
            &:hover{
                transition: .4s;
                background-color: lighten(#374d85, 15%);
            }
        }
    }
    .waiting{
        display: flex;
        justify-content: center;
        div{
            height: 5px;
            width: 5px;
            background-color: #fff;
            margin: .25em;
            border-radius: 50%;
            position: relative;

            // animation-delay: 10s;
            animation-name: loading;
            animation-iteration-count: infinite;
            animation-duration: .85s;
            animation-direction: alternate;
            animation-timing-function: ease-in;
            &:nth-child(2) {
                animation-delay: .25s;
            }
            &:nth-child(3) {
                animation-delay: .5s;
            }
        }
    }
    .complite{
        text-align: center;
    }
    @keyframes loading {
        from{
            top: -4px;
        }
        to{
            top: 4px;
        }
    }
}
.bf.__slot{
    margin-bottom: 20px;
}
</style>